
export default class SideMenu {
    
    static get selector() {
        return '.sideNav';
    }

    constructor(el) {
        this.el = el;
        this.burger = document.body.querySelector('.gotomenu');
        this.setEvents();
    }

    toggle() {
        if(this.isOpen) this.close();
        else this.open()
    }

    open() {
        if(this.isOpen) return;
        window.dispatchEvent( new CustomEvent('vegout-filter-close'));

        document.body.classList.add('sideMenu');
        this.isOpen = true;
    }

    close() {
        if(!this.isOpen) return;
        document.body.classList.remove('sideMenu');
        this.isOpen = false;
    }

    setEvents() {
        this.burger.addEventListener('click', this.e_clickBurger.bind(this) );
        document.addEventListener('click', this.e_click.bind(this));
        window.addEventListener('vegout-close-menu', this.e_closeMenu.bind(this));

    }

    e_clickBurger(e){
        e.preventDefault();
        this.toggle();
    }

    e_click(e){
        if(!this.isOpen) return;
        let isClickInside = this.el.contains(e.target) || this.burger.contains(e.target);
        if (!isClickInside) this.close();
    }

    e_closeMenu(e) {
        this.close();
    }
}